import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Project, ProjectCard } from 'src/app/core/models/project-pilot.model';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';

@Component({
  selector: 'app-project-insight',
  templateUrl: './project-insight.component.html',
  styleUrls: ['./project-insight.component.scss']
})
export class ProjectInsightComponent implements OnInit {
  public project: Project[] = [];
  public isLoading: boolean = true;
  public count = 3;
  public employeeCount!: number;
  public projectCard: ProjectCard;
  public privilege: PrivilegeType;
  public context: Context;
  private subscription: any;

  constructor(
    private projectPilotService: ProjectPilotService,
    private commonService: CommonService,
    private authService: AuthService,
    private dataService: DataService,
    private modalService: NgbModal,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.subscription = this.authService.getContext().subscribe(context => {
      this.context = context;
      if (context.projectId) {
        this.getProjectCard();
      }
    });
    this.getProjectInsights();
  }

  public getProjectInsights(clear: boolean = true) {
    this.projectPilotService.getProjectInsights(this.count).subscribe({
      next: (project: Project[]) => {
        this.project = project;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public getProjectCard() {
    this.projectPilotService.getProjectCard(this.context.projectId).subscribe({
      next: (project: ProjectCard) => {
        this.projectCard = project;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public createProject(project?: Project) {
    this.router.navigate(['/project-pilot/manage-project'],
      { queryParams: {pId: project?.id } }
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
